import { Project, ProjectResponse, ProjectsResponse } from '../types';
import {api} from './api';
import { privateLambdaService } from './privateLambdaService';

// export interface Project {
//   id: string;
//   name: string;
//   description: string;
//   createdAt: string;
//   updatedAt: string;
//   status: string;
// }

export interface CreateProjectRequest {
  name: string;
  description: string;
  requirementType: string;
  figmaDesignUrl?: string;
  figmaAccessToken?: string;  // Required when figmaDesignUrl is provided
}

export interface UpdateProjectRequest {
  name?: string;
  description?: string;
  status?: string;
}

export const projectService = {
  /**
   * Get all projects
   */
  getAllProjects: async (): Promise<ProjectsResponse> => {
    try {
      return await privateLambdaService.getAllProjects();
    } catch (error) {
      console.error('Error getting all projects:', error);
      throw error; // Re-throw to propagate backend error messages
      
      // FALLBACK TO PUBLIC API DISABLED - Backend error messages should be shown to users
      // const response = await api.get('/projects');
      // return response.data;
    }
  },

  /**
   * Get a project by ID
   */
  getProjectById: async (id: string): Promise<ProjectResponse> => {
    try {
      return await privateLambdaService.getProjectById(id);
    } catch (error) {
      console.error('Error getting project by ID:', error);
      throw error; // Re-throw to propagate backend error messages
      
      // FALLBACK TO PUBLIC API DISABLED - Backend error messages should be shown to users
      // const response = await api.get(`/projects/${id}`);
      // return response.data;
    }
  },

  /**
   * Create a new project
   */
  createProject: async (projectData: CreateProjectRequest): Promise<ProjectResponse> => {
    try {
      return await privateLambdaService.createProject(projectData);
    } catch (error) {
      console.error('Error creating project:', error);
      throw error; // Re-throw to propagate backend error messages
      
      // FALLBACK TO PUBLIC API DISABLED - Backend error messages should be shown to users
      // const response = await api.post('/projects', projectData);
      // return response.data;
    }
  },

  /**
   * Update a project
   */
  updateProject: async (id: string, projectData: UpdateProjectRequest): Promise<Project> => {
    try {
      return await privateLambdaService.updateProject(id, projectData);
    } catch (error) {
      console.error('Error updating project:', error);
      throw error; // Re-throw to propagate backend error messages
      
      // FALLBACK TO PUBLIC API DISABLED - Backend error messages should be shown to users
      // const response = await api.put(`/projects/${id}`, projectData);
      // return response.data;
    }
  },

  /**
   * Delete a project
   */
  deleteProject: async (id: string): Promise<void> => {
    try {
      await privateLambdaService.deleteProject(id);
    } catch (error) {
      console.error('Error deleting project:', error);
      throw error; // Re-throw to propagate backend error messages
      
      // FALLBACK TO PUBLIC API DISABLED - Backend error messages should be shown to users
      // await api.delete(`/projects/${id}`);
    }
  },

  // Review functionality methods (previously added)
  getReviewStages: async (projectId: string) => {
    try {
      return await privateLambdaService.getReviewStages(projectId);
    } catch (error) {
      console.error('Private Lambda failed for review stages:', error);
      throw error; // No fallback for review functionality as it's new
    }
  },

  getStageOutput: async (projectId: string, stage: string) => {
    try {
      return await privateLambdaService.getStageOutput(projectId, stage);
    } catch (error) {
      console.error('Private Lambda failed for stage output:', error);
      throw error;
    }
  },

  submitReview: async (projectId: string, stage: string, formData: FormData) => {
    try {
      return await privateLambdaService.submitReview(projectId, stage, formData);
    } catch (error) {
      console.error('Private Lambda failed for submit review:', error);
      throw error;
    }
  },

  regenerateStage: async (projectId: string, stage: string, formData: FormData) => {
    try {
      return await privateLambdaService.regenerateStage(projectId, stage, formData);
    } catch (error) {
      console.error('Private Lambda failed for regenerate stage:', error);
      throw error;
    }
  },

  getReviewHistory: async (projectId: string, stage: string) => {
    try {
      return await privateLambdaService.getReviewHistory(projectId, stage);
    } catch (error) {
      console.error('Private Lambda failed for review history:', error);
      throw error;
    }
  },
};

export default projectService;